import { Directive, Input } from '@angular/core';
import { FormControl, NG_VALIDATORS } from '@angular/forms';
import { TgValidationDirective } from '@trademe/tangram';
// Type copied locally — ValidatorConfig is not exported in @trademe/tangram public API
export interface ValidatorConfig {
    message?: (() => string) | string;
    validator?: import('@angular/forms').AsyncValidatorFn | import('@angular/forms').ValidatorFn;
}

@Directive({
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: '[validation]',
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: ValidationSchemaDirective,
            multi: true
        }
    ],
    standalone: false
})
export class ValidationSchemaDirective extends TgValidationDirective {
    @Input() public override validation: any;

    public override validate(ctrl: FormControl) {
        for (const k in this.validation) {
            const error = (<ValidatorConfig>this.validation[k]).validator(ctrl);
            if (error != null) {
                return error;
            }
        }

        return null;
    }
}
